import './AIFree.css';
import {Link} from 'react-router-dom'
import React from "react";
import Footer from '../Footer';

function AIFree(props) {

    return (
        <div className="type">
            <Link className="link" to="/" >
                <p className="backButton"> back to home </p>
            </Link>
                <h1 className="calHeaderTextUpper"> AI-FREE  </h1>
                <h2 className="calHeaderTextLower">  commitment </h2>
                 <p className="storyBodyText"> coming soon! </p>
            <Footer/>
        </div>

    )

}

export default AIFree;